<router-outlet></router-outlet>

<div class="img-preview-overlay" *ngIf="previewUrl$ | async as url" (click)="closePreview()">
    <div class="img-preview-content" (click)="$event.stopPropagation()">
        <button class="img-preview-close" (click)="closePreview()">
            <span class="material-icons">close</span>
        </button>
        <img class="img-preview-img" [src]="url">
    </div>
</div>
